/**
 * Copyright 2014, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var Fluxible = require('./lib/Fluxible');
Fluxible.Fluxible = require('./lib/Fluxible');

module.exports = Fluxible;



//////////////////
// WEBPACK FOOTER
// ./~/fluxible/index.js
// module id = 429
// module chunks = 20 22 23 25